import React, { useMemo, useState, useEffect } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Formik } from 'formik';
import { isEqual } from 'lodash';
import { useProductsUIContext } from '../ProductsUIContext';
import { productTypeList, productStatusList } from '../ProductsUIHelpers';
import axios, { baseUrl } from '../../../../../../redux/my-axios';

const PARAM_URL = '/params';
const prepareFilter = (queryParams, values) => {
  const {
    categoryCode,
    brandCode,
    typeCode,
    websiteCode,
    searchText,
    status,
  } = values;
  const newQueryParams = { ...queryParams };
  const filter = {};
  filter.categoryCode = categoryCode !== '' ? categoryCode : undefined;
  filter.brandCode = brandCode !== '' ? brandCode : undefined;
  filter.typeCode = typeCode !== '' ? typeCode : undefined;
  filter.status = status !== '' ? status : undefined;
  filter.websiteCode = websiteCode !== '' ? websiteCode : undefined;

  if (searchText) {
    filter.searchText = searchText;
  }
  newQueryParams.filter = filter;
  //console.log('filter=', newQueryParams.filter);
  return newQueryParams;
};

const ProductsFilter = (props) => {
  const [loaded, setLoaded] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [websiteList, setWebsiteList] = useState([]);
  const ProductsUIContext = useProductsUIContext();
  const ProductsUIProps = useMemo(() => {
    return {
      queryParams: ProductsUIContext.queryParams,
      setQueryParams: ProductsUIContext.setQueryParams,
    };
  }, [ProductsUIContext]);

  useEffect(() => {
    const storeKeyCategory = 'categoryList';
    let listCategory = undefined;
    if (categoryList !== []) {
      //listCategory = localStorage.getItem(storeKeyCategory);
      if (listCategory) {
        setCategoryList(JSON.parse(listCategory));
      } else {
        axios
          .post(PARAM_URL, 'getcategorylist', {
            headers: { action: 'getcategorylist' },
          })
          .then((response) => {
            switch (response.data.type) {
              case 'SUCCESS':
              case 'SUCCESS_WITH_WARNING':
              case 'SUCCESS_WITH_INFO':
                setCategoryList(response.data.data);
                localStorage.setItem(
                  storeKeyCategory,
                  JSON.stringify(response.data.data)
                );
                break;
              default:
                break;
            }
          })
          .catch((error) => {});
      }
    } else {
      listCategory = localStorage.getItem(storeKeyCategory);
      if (!listCategory) {
        // LocalStorage-s setleh
        localStorage.setItem(storeKeyCategory, JSON.stringify(categoryList));
      }
      setLoaded(true);
    }

    const storeKeyBrand = 'brandList';
    let listBrand = undefined;
    if (brandList !== []) {
      //listBrand = localStorage.getItem(storeKeyBrand);
      if (listBrand) {
        setBrandList(JSON.parse(listBrand));
      } else {
        axios
          .post(PARAM_URL, 'getbrandlist', {
            headers: { action: 'getbrandlist' },
          })
          .then((response) => {
            switch (response.data.type) {
              case 'SUCCESS':
              case 'SUCCESS_WITH_WARNING':
              case 'SUCCESS_WITH_INFO':
                setBrandList(response.data.data);
                localStorage.setItem(
                  storeKeyBrand,
                  JSON.stringify(response.data.data)
                );
                break;
              default:
                break;
            }
          })
          .catch((error) => {});
      }
    } else {
      listBrand = localStorage.getItem(storeKeyBrand);
      if (!listBrand) {
        // LocalStorage-s setleh
        localStorage.setItem(storeKeyBrand, JSON.stringify(brandList));
      }
      setLoaded(true);
    }

    const storeKeyWebsite = 'websiteList';
    let listWebsite = undefined;
    if (websiteList !== []) {
      //listWebsite = localStorage.getItem(storeKeyWebsite);
      if (listWebsite) {
        setWebsiteList(JSON.parse(listWebsite));
      } else {
        axios
          .post(PARAM_URL, 'getwebsitelist', {
            headers: { action: 'getwebsitelist' },
          })
          .then((response) => {
            switch (response.data.type) {
              case 'SUCCESS':
              case 'SUCCESS_WITH_WARNING':
              case 'SUCCESS_WITH_INFO':
                setWebsiteList(response.data.data);
                localStorage.setItem(
                  storeKeyWebsite,
                  JSON.stringify(response.data.data)
                );
                break;
              default:
                break;
            }
          })
          .catch((error) => {});
      }
    } else {
      listWebsite = localStorage.getItem(storeKeyWebsite);
      if (!listWebsite) {
        localStorage.setItem(storeKeyWebsite, JSON.stringify(websiteList));
      }
      setLoaded(true);
    }

    return function cleanup() {
      setCategoryList([]);
      setBrandList([]);
      setWebsiteList([]);
    };
  }, [loaded]);
  // queryParams, setQueryParams,
  const applyFilter = (values) => {
    //console.log("applyFilter", values);
    const newQueryParams = prepareFilter(ProductsUIProps.queryParams, values);
    //console.log("applyFilter prepareFilter..", newQueryParams);
    if (!isEqual(newQueryParams, ProductsUIProps.queryParams)) {
      //console.log("!isEqual before");
      newQueryParams.pageNumber = 1;
      // update list by queryParams
      //console.log(newQueryParams);
      ProductsUIProps.setQueryParams(newQueryParams);
      //console.log("!isEqual after...", ProductsUIProps.queryParams);
    }
  };

  return (
    <>
      <Formik
        initialValues={{
          categoryCode: '',
          brandCode: '',
          typeCode: '',
          websiteCode: '',
          status: -1,
          searchText: '',
        }}
        onSubmit={(values) => {
          //console.log("                                         ");
          //console.log("=============== SUBMIT =================");
          applyFilter(values);
        }}
      >
        {({
          values,
          handleSubmit,
          handleBlur,
          handleChange,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit} className='form form-label-right'>
            <div className='form-group row'>
              <div className='col-lg-2'>
                <select
                  className='form-control'
                  name='typeCode'
                  onBlur={handleBlur}
                  onChange={(e) => {
                    setFieldValue('typeCode', e.target.value);
                    handleSubmit();
                  }}
                  value={values.typeCode}
                >
                  {productTypeList.map((option) => (
                    <option
                      key={`productTypeList${option.code}`}
                      value={option.code}
                    >
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className='col-lg-2'>
                <select
                  className='form-control'
                  name='categoryCode'
                  onBlur={handleBlur}
                  onChange={(e) => {
                    setFieldValue('categoryCode', e.target.value);
                    handleSubmit();
                  }}
                  value={values.categoryCode}
                >
                  {categoryList.map((option) => (
                    <option
                      key={`categoryList${option.code}`}
                      value={option.code}
                    >
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className='col-lg-2'>
                <select
                  className='form-control'
                  name='brandCode'
                  onBlur={handleBlur}
                  onChange={(e) => {
                    setFieldValue('brandCode', e.target.value);
                    handleSubmit();
                  }}
                  value={values.brandCode}
                >
                  {brandList.map((option) => (
                    <option key={`brandList${option.code}`} value={option.code}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>

              {/*  <div className='col-lg-2'>
                <select
                  className='form-control'
                  name='websiteCode'
                  onBlur={handleBlur}
                  onChange={(e) => {
                    setFieldValue('websiteCode', e.target.value);
                    handleSubmit();
                  }}
                  value={values.websiteCode}
                >
                  {websiteList.map((option) => (
                    <option
                      key={`websiteList${option.code}`}
                      value={option.code}
                    >
                      {option.name}
                    </option>
                  ))}
                </select>
              </div> */}
              <div className='col-lg-2'>
                <select
                  className='form-control'
                  name='status'
                  onBlur={handleBlur}
                  onChange={(e) => {
                    setFieldValue('status', e.target.value);
                    handleSubmit();
                  }}
                  value={values.status}
                >
                  {productStatusList.map((option) => (
                    <option
                      key={`productStatusList${option.code}`}
                      value={option.code}
                    >
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className='col-lg-2'>
                <input
                  type='text'
                  className='form-control'
                  name='searchText'
                  placeholder='текст'
                  onBlur={handleBlur}
                  value={values.searchText}
                  onChange={(e) => {
                    setFieldValue('searchText', e.target.value);
                    handleSubmit();
                  }}
                />
              </div>

              <div className='col-lg-2'>
                <button
                  id='kt_product_search_submit'
                  type='submit'
                  /* disabled={formik.isSubmitting} */
                  className={`btn btn-primary font-weight-bold`}
                  /* onClick={() => {
                                    //setFieldValue("loading", true);
                                    handleSubmit();
                                }} */
                >
                  <FormattedMessage id='PRODUCT.LABEL.SEARCH' />
                  {/*   <span><FormattedMessage id="AUTH.LOGIN.BUTTON" /></span> */}
                  {/* {values.loading && <span className="ml-3 spinner spinner-white"></span>} */}
                </button>
              </div>
            </div>
          </form>
        )}
      </Formik>
    </>
  );
};

export default injectIntl(ProductsFilter);
